import React, { useEffect, useRef, useState } from "react";
import { Column, Histogram, Line } from "@ant-design/plots";
import {  Select, Space } from "antd";
import { PieChartOutlined, LineChartOutlined } from "@ant-design/icons";
import { DatePicker } from "antd-jalali";
import dayjs from "dayjs";
import styles from "./Report.module.css";
import api from "../../api/api";
import { connect } from "react-redux";
import * as actions from "../../store/actions/action";

import TableExportDropdown from "../../Components/TableExportDropdown/TableExportDropdown";
import { SearchColumn } from "../../Components/TableSettings/TableSettings";
import PersianToCalendars from "../../util/PersianToCalendars";
import DataTable from "../../Components/DataTable/DataTable";
import { PageHeader } from "@ant-design/pro-components";

const Report = ({ ErrorSetter, token }) => {
  const [chartType, setChartType] = useState("Column");
  const [range, setRange] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const theme = "default";
  const config = {
    data,
    isGroup: true,
    xField: "date",
    yField: "count",
    seriesField: "category",
    // colorField: 'category',
    legend: {
      layout: "horizontal",
      position: "bottom",
      offsetY: 2,
      itemSpacing: 64,
      marker: { spacing: -16 },
    },
    label: {
      position: "middle",

      layout: [
        {
          type: "interval-adjust-position",
        },
        {
          type: "interval-hide-overlap",
        },
        {
          type: "adjust-color",
        },
      ],
    },
    color: ["#6d8eea", "#DDB27C", "lightseagreen"],
    theme,
    loading,
  };
  const lineConfig = {
    data,
    loading,
    xField: "date",
    yField: "count",
    sizeField: "count",
    shapeField: "trail",
    legend: { size: false },
    colorField: "category",
    seriesField: "category",
    color: ["#6d8eea", "#DDB27C", "lightseagreen"],
    legend: {
      layout: "horizontal",
      position: "bottom",
      offsetY: 2,
      itemSpacing: 64,
      marker: { spacing: -24 },
    },

    point: {
      shapeField: "square",
      sizeField: 1,
    },
    style: {
      lineWidth: 8,
    },
  };
  const AuthHeader = { Authorization: "Token " + token };

  const fetchData = () => {
    setLoading(true);

    api
      .get(
        `/conversion-rate?start=${
          new Date(range[0]).toISOString().split("T")[0]
        }&end=${new Date(range[1]).toISOString().split("T")[0]}`,
        {
          headers: { ...AuthHeader },
        }
      )
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        ErrorSetter("دریافت اطلاعات با مشکل مواجه شد، صفحه را ریفرش کنید");
      });
  };
  useEffect(() => {
    setRange([
      dayjs(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 0), {
        jalali: true,
      }),
      dayjs(new Date(), { jalali: true }),
    ]);
  }, []);
  useEffect(() => {
    if (Array.isArray(range)) {
      fetchData();
      console.log(
        "\nStart Date:",
        dayjs(range[0], "DD-MM-YYYY").toISOString(),
        "\n\nEnd Date:",
        dayjs(range[1], "DD-MM-YYYY").toISOString()
      );
    }
  }, [range]);

  let chart = null;

  const Search = new SearchColumn(
    searchText,
    setSearchText,
    searchedColumn,
    setSearchedColumn,
    searchInput
  );
  const columns = [
    {
      title: "تاریخ",
      dataIndex: "date",
      key: "date",
      ...Search.getColumnSearchProps("date"),
      render: (text, record, index) => {
        const date = record.date;

        const jalaliDate = dayjs(date, { jalali: true });
        const arrayDate = `${date}`.split("-");
        console.log(arrayDate[0]);
        return (
          <div>
            <span style={{ direction: "rtl" }}>
              {date} -  {" "}
            </span>
            <span style={{ direction: "rtl" }}>
              {jalaliDate && Array.isArray(arrayDate) &&
                PersianToCalendars(
                  +arrayDate[0],
                  +arrayDate[1],
                  +arrayDate[2],
                  {
                    toCal: "persian",
                    dateStyle: "full",
                    locale: "fa",
                  }
                )}
            </span>

            <span> - {jalaliDate.fromNow()}</span>
          </div>
        );
      },
    },
    {
      title: "تعداد درخواست‌ها",
      dataIndex: "درخواست‌ها",
      key: "درخواست‌ها",
      sorter: (a, b) => {
        return a["درخواست‌ها"] > b["درخواست‌ها"];
      },
      sortDirections: ["descend", "ascend"],
      ...Search.getColumnSearchProps("درخواست‌ها"),
    },
    {
      title: "تعداد پیگیری‌ها",
      dataIndex: "پیگیری‌ها",
      key: "پیگیری‌ها",
      sorter: (a, b) => {
        return a["پیگیری‌ها"] > b["پیگیری‌ها"];
      },
      sortDirections: ["descend", "ascend"],
      ...Search.getColumnSearchProps("پیگیری‌ها"),
    },

    {
      title: "تعداد ثبت نام",
      dataIndex: "ثبت‌نام",
      key: "ثبت‌نام",
      sorter: (a, b) => {
        return a["ثبت‌نام"] > b["ثبت‌نام"];
      },
      sortDirections: ["descend", "ascend"],
      ...Search.getColumnSearchProps("ثبت‌نام"),
    },
  ];

  const aggregatedData = {};

  data.forEach((entry) => {
    const { date, category, count } = entry;
    if (!aggregatedData[date]) {
      aggregatedData[date] = { date: date };
    }
    if (!aggregatedData[date][category]) {
      aggregatedData[date][category] = 0;
    }
    aggregatedData[date][category] += count;
  });
  const dataSource = Object.values(aggregatedData);

  switch (chartType) {
    case "Column":
      chart = <Column {...config} />;
      break;
    case "Line":
      chart = <Line {...lineConfig} />;
      break;
    case "Table":
      chart = (
        <DataTable
          columns={columns}
          dataSource={dataSource}
          loading={loading}
        />
      );

      break;
    default:
      chart = <Column {...config} />;
  }
  if (data.length === 0 && loading === false) {
    chart = (
      <div className={styles.NoData}>
        <LineChartOutlined />
        <h1>دیتایی موجود نیست!</h1>
      </div>
    );
  }

  return (
    <div
      style={{ direction: "ltr", overflowX: "hidden", position: "relative" }}
    >
      <PageHeader
        className="site-page-header"
        title="نمودار نرخ لید و ثبت‌نام"
        avatar={{ icon: <PieChartOutlined /> }}
        extra={
          <Space>
            <TableExportDropdown
              columns={columns}
              data={dataSource}
              disabled={loading}
              name="گزارش"
            />
            <DatePicker.RangePicker
              value={range}
              onChange={(dates) => {
                setRange(dates);
              }}
            />
            <Select
              value={chartType}
              onChange={(value) => {
                setChartType(value);
              }}
            >
              <Select.Option value="Column">ستونی</Select.Option>
              <Select.Option value="Line">خطی</Select.Option>
              <Select.Option value="Table">جدولی</Select.Option>
            </Select>
          </Space>
        }
      />
      <div style={{ position: "relative" }}>{chart}</div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    token: state.token,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ErrorSetter: (error, errorType) =>
      dispatch(actions.ErrorSetter(error, errorType)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Report);
